import React from 'react';
import {
    withStyles,
    Grid
} from '@material-ui/core';
import DataTable from "../../components/data-table/DataTable";
import {getReportConsumption, getReportConsumptionUrl} from "../../services/goods";
import ActionButton from "../../components/button/ActionButton";
import { connect } from "react-redux";
import moment from 'moment';
import DatePeriodField from "../../components/fields/DatePeriodField";

const columnData = [
    { id: 'name', label: '' },
    { id: 'category', label: '' },
    { id: 'description', label: '', minWidth: 600 },
    { id: 'sumMoneyFormatted', label: 'Потребление в денежных единицах' },
    { id: 'sumMassFormatted', label: 'Потребление в массе' },
    { id: 'count', label: 'Потребление в шт.' },
    { id: 'parlour', label: 'Салон' },
];


const styles = theme => ({
    minWidth: {
        minWidth: 800,
    },
});

class ReportConsumption extends React.Component
{
    state = {
        from: moment().subtract(7, 'days'),
        to: moment(),
        refreshTable: false,
    };

    getPeriod = () => {
        const { from, to } = this.state;
        return {
            from: from.format('YYYY-MM-DD'),
            to: to.format('YYYY-MM-DD'),
        }
    };

    getTableData = (...params) => {
        return getReportConsumption(this.getPeriod(), ...params);
    };

    handleDateChange = prop => date => {
        this.setState({
            [prop]: date,
            refreshTable: !this.state.refreshTable,
        })
    };

    render() {
        const { token, classes } = this.props;
        const { from, to, refreshTable } = this.state;

        return (
            <Grid container spacing={2} className={classes.minWidth}>
                <Grid item xs={9}>Расчет потребления за единицу времени</Grid>
                <Grid item xs={9}>
                    <DatePeriodField
                        label="Период"
                        valueFrom={from}
                        valueTo={to}
                        onChangeFrom={this.handleDateChange('from')}
                        onChangeTo={this.handleDateChange('to')}
                    />
                </Grid>
                <Grid item xs={3}><ActionButton href={getReportConsumptionUrl({access_token: token.access_token, xls: 1, search: this.getPeriod()})} marginLabeledFields>Выгрузить в Excel</ActionButton></Grid>
                <Grid item xs={12}>
                    <DataTable
                        columnData={columnData}
                        dataFunc={this.getTableData}
                        selector={false}
                        refresh={refreshTable}
                    />
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = state => ({
    token: state.auth.token,
});

export default connect(mapStateToProps, {})(withStyles(styles)(ReportConsumption));
